'use strict';

var _ = require('lodash');
var tooltipTemplateHtml = require('../templates/demand-posting-selected-criteria-tooltip.html');
var DemandPostingPanelDirective = function DemandPostingPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-posting-panel.html'),
    controller: 'DemandPostingPanelController',
    scope: {
      contextData: '=',
      screenState: '=',
      dimension: '='
    },
    link: function link($scope, $element) {
      var infoIcon = $element.find('.dp-info-icon');
      var tooltipContentTemplate = _.template(tooltipTemplateHtml);
      infoIcon.popover({
        content: tooltipContentTemplate({
          labels: $scope.tooltipContent
        }).replace(/>\s*</g, '><'),
        html: true,
        trigger: 'focus',
        placement: 'bottom',
        container: 'body'
      });
      $scope.$on('$destroy', function () {
        infoIcon.popover('destroy');
      });
    }
  };
};
DemandPostingPanelDirective.$inject = [];
module.exports = DemandPostingPanelDirective;